import { Link } from "react-router-dom";
import React, { useState } from 'react';
import OverLay from "../HomePage/OverLay";
const Footer = () => {

    const [showAppointmentSidebar, setShowAppointmentSidebar] = useState(false);
    const [activeTab, setActiveTab] = useState('book-appointment');




    const onContactUs = (activetab) => {
        setShowAppointmentSidebar(true);
        setActiveTab(activetab);
    }


    return (
        <div>
            {/* Book Appointment */}

              {/* Book Appointment */}
              <section className="over_lay">

                
<OverLay
    showAppointmentSidebar={showAppointmentSidebar}
    activeTab={activeTab}
    setActiveTab={setActiveTab}
    setShowAppointmentSidebar={setShowAppointmentSidebar} 
  
/>

</section>

{/* Book Appointment End */}

           

            {/* Book Appointment End */}
            <footer className="footer">
                <div className="container">
                    <div className="row">
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-6">
                            <div className="footer_logo">
                                <img src="images/logo-white.png" alt="" />
                                <h2>Contact Us</h2>
                                <p>9250 E. Costilla Ave #620 Greenwood Village CO 80112</p>
                            </div>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-6">
                            <div className="footer_logo quick_link">
                                <h2>Quick Links</h2>
                                <div className="quick_link_inner">
                                    <ul>
                                        <li><Link to="/aboutus"><img src="images/footer-arrow.svg" alt="" /> About Us</Link>
                                        </li>
                                    
                                        <li><Link className="nav-link" to="/financing-services"><img src="images/footer-arrow.svg" alt="" />Apply for Financing</Link> 
                                        </li>
                                        <li>
                                        <Link className="nav-link" to="/privacypolicy">
                                            <img src="images/footer-arrow.svg" alt="" /> Privacy Policy</Link> </li>
                                        {/* <li><a href="#"><img src="images/footer-arrow.svg" alt="" /> Sitemap</a></li> */}
                                    </ul>
                                    <ul>
                                        <li className="book_appointment_click" onClick={() => onContactUs('book-appointment')}><img src="images/footer-arrow.svg" alt="" /> Book an
                                            Appointment</li>
                                        <li className="club_membership_click" onClick={() => onContactUs('club-membership')}><img src="images/footer-arrow.svg" alt="" /> Club
                                            Membership</li>

                                        <li className="book_appointment_click" onClick={() => onContactUs('contact-us')}><    ><img src="images/footer-arrow.svg" alt="" /> Contact Us</></li>
                                        {/* <li><a href="#"><img src="images/footer-arrow.svg" alt="" /> Contact Us</li></a> */}
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-6">
                            <div className="quick_link_email">
                                <ul>
                                    <li><a href="mailto:Help@sparks-hvac.com"><img src="images/email.svg" alt="" />
                                        Help@sparks-hvac.com</a></li>
                                    <li><a href="tel:3035214037"><img src="images/call.svg" alt="" />303-521-4037</a></li>
                                </ul>
                                <div className="follow_wepper">
                                    <h2>Follow Us On -</h2>
                                    <div className="social_media">
                                        <ul>
                                            <li><a target="_blank" href="https://www.instagram.com/sparksheatingandair/#"><i className="fa-brands fa-instagram"></i></a></li>
                                            <li><a href="https://www.facebook.com/sparksheatingandair" target="_blank" ><i className="fa-brands fa-facebook-f"></i></a></li>
                                            <li><a target="_blank" href="https://www.youtube.com/channel/UCMb6_Uk-xOHGdbWnHuKFyMQ"><i className="fa-brands fa-youtube"></i></a></li>
                                            <li><a target="_blank" href="https://www.linkedin.com/company/sparks-heating-and-air-llc"><i className="fa-brands fa-linkedin-in"></i></a></li>
                                            <li><a target="_blank" href="https://x.com/sparks_air"><i className="fa-brands fa-x"></i></a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div className="copy_right">
                        <hr />
                        <p>Copyright © 2024</p>
                    </div>
                </div>
            </footer>
        </div>

    )
}

export default Footer;